/* Gloupix — ajout panier AJAX, compteur, barre "minimum 2 articles", carrousels, galerie, vidéos */
(function () {
  var MIN = 1;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function plural(n, w) { return n + ' ' + w + (n > 1 ? 's' : ''); }

  function updateProgress(count) {
    document.querySelectorAll('[data-gx-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
    document.querySelectorAll('[data-gx-progress]').forEach(function (box) {
      var missing = Math.max(0, MIN - count);
      var ok = missing === 0;
      box.classList.toggle('is-ok', ok);
      var fill = box.querySelector('[data-gx-fill]');
      if (fill) fill.style.width = Math.min(100, (count / MIN) * 100) + '%';
      var t = box.querySelector('[data-gx-ptitle]');
      if (t) t.textContent = ok ? (box.dataset.okTitle || 'Minimum atteint : tu peux passer commande !') : 'Encore ' + plural(missing, 'article') + ' pour pouvoir commander';
      var c = box.querySelector('[data-gx-pcount]');
      if (c) c.textContent = 'Ton panier : ' + plural(count, 'article');
      var r = box.querySelector('[data-gx-pright]');
      if (r) r.textContent = ok ? 'Validé !' : 'Encore ' + missing + ' !';
      var n = box.querySelector('[data-gx-pnote]');
      if (n) n.textContent = ok ? 'Tu peux passer commande.' : 'Minimum ' + MIN + ' articles par commande pendant le Black Friday.';
      box.querySelectorAll('[data-gx-face]').forEach(function (f) { f.hidden = (f.dataset.gxFace === 'ok') !== ok; });
    });
  }

  var MASCOT = '<svg viewBox="0 0 200 200" aria-hidden="true" focusable="false"><path d="M100 20 C150 20 180 54 180 98 C180 140 158 174 126 176 C114 177 112 164 102 164 C92 164 90 182 76 182 C62 182 62 166 52 164 C24 160 16 132 16 98 C16 54 50 20 100 20 Z" fill="#8BE04E" stroke="#2B1A4A" stroke-width="10"/><path d="M58 90 q14 -14 28 0 M114 90 q14 -14 28 0" fill="none" stroke="#2B1A4A" stroke-width="10" stroke-linecap="round"/><path d="M70 118 Q99 156 128 118 Z" fill="#FF5FA2" stroke="#2B1A4A" stroke-width="10" stroke-linejoin="round"/></svg>';

  function toast(title, sub, isError) {
    var el = document.querySelector('.gx-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'gx gx-toast';
      el.setAttribute('role', 'status');
      el.innerHTML = '<span class="gx-toast__mascot">' + MASCOT + '</span><span class="gx-toast__txt"><strong class="gx-toast__title"></strong><span class="gx-toast__sub"></span></span><a class="gx-toast__btn" href="' + root + 'cart">Voir le panier</a><button type="button" class="gx-toast__close" aria-label="Fermer">×</button>';
      el.querySelector('.gx-toast__close').addEventListener('click', function () { el.classList.remove('is-on'); });
      document.body.appendChild(el);
    }
    el.classList.toggle('is-error', !!isError);
    el.querySelector('.gx-toast__title').textContent = title;
    el.querySelector('.gx-toast__sub').textContent = sub || '';
    el.style.bottom = (document.querySelector('.gx-sticky') && window.innerWidth < 750) ? '92px' : '';
    el.classList.remove('is-on');
    void el.offsetWidth;
    el.classList.add('is-on');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-on'); }, 4000);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-gx-add]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btns = Array.prototype.slice.call(document.querySelectorAll('button[type="submit"][form="' + form.id + '"]'));
    form.querySelectorAll('button[type="submit"]').forEach(function (b) { btns.push(b); });
    btns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateProgress(cart.item_count);
        var missing = Math.max(0, MIN - cart.item_count);
        if (form.hasAttribute('data-gx-reload')) { window.location.reload(); return; }
        try { form.dispatchEvent(new CustomEvent('gx:added', { bubbles: true })); } catch (e) {}
        openDrawerAdded();
      })
      .catch(function (err) {
        toast('Oups !', (err && (err.description || err.message)) || 'Impossible d\'ajouter cet article.', true);
      })
      .finally(function () { btns.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); }); });
  });

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-gx-step]');
    if (q) {
      var input = q.closest('.gx-qty').querySelector('input');
      var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(q.dataset.gxStep, 10));
      input.value = v;
      document.querySelectorAll('[data-gx-sync-qty="' + input.id + '"]').forEach(function (el) { el.value = v; });
      return;
    }
    var t = e.target.closest('[data-gx-thumb]');
    if (t) {
      var wrap = t.closest('[data-gx-gallery]');
      var main = wrap.querySelector('[data-gx-main]');
      main.src = t.dataset.gxThumb; main.srcset = ''; main.alt = t.dataset.alt || '';
      wrap.querySelectorAll('[data-gx-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); x.setAttribute('aria-pressed', x === t); });
      return;
    }
    var p = e.target.closest('[data-gx-play]');
    if (p) {
      var item = p.closest('.gx-ugc__item');
      var v2 = item && item.querySelector('video');
      if (v2) { item.classList.add('is-playing'); v2.controls = true; v2.play(); }
    }
  });

  function initRails() {
    document.querySelectorAll('[data-gx-rail]').forEach(function (rail) {
      if (rail._gx) return; rail._gx = true;
      var host = rail.closest('[data-gx-railhost]') || rail.parentNode;
      var dots = host.querySelector('[data-gx-dots]');
      var counter = host.querySelector('[data-gx-counter]');
      var items = rail.children;
      if (!items.length) return;
      var pages = 0;
      function measure() {
        var step = items[0].getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 14);
        var maxScroll = rail.scrollWidth - rail.clientWidth;
        pages = maxScroll <= 2 ? 1 : Math.round(maxScroll / step) + 1;
        if (counter) pages = items.length;
        if (dots) {
          dots.innerHTML = '';
          if (pages > 1) for (var i = 0; i < pages; i++) dots.appendChild(document.createElement('span'));
        }
        sync();
      }
      function sync() {
        var step = items[0].getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 14);
        var idx = Math.min(pages - 1, Math.round(rail.scrollLeft / step));
        if (dots) Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === idx); });
        if (counter) counter.textContent = (idx + 1) + '/' + items.length;
      }
      rail.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', measure);
      measure();
    });
  }

  function init() {
    initRails();
    document.querySelectorAll('[data-gx-variant]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var o = sel.options[sel.selectedIndex];
        var box = document.querySelector('[data-gx-pricebox="' + sel.dataset.gxVariant + '"]');
        if (!box) return;
        var now = box.querySelector('[data-gx-now]'), was = box.querySelector('[data-gx-was]'), off = box.querySelector('[data-gx-off]');
        if (now) now.textContent = o.dataset.price;
        if (was) { was.textContent = o.dataset.compare || ''; was.hidden = !o.dataset.compare; }
        if (off) { off.textContent = o.dataset.off ? '-' + o.dataset.off + ' %' : ''; off.hidden = !o.dataset.off; }
        document.querySelectorAll('[data-gx-sticky-now]').forEach(function (s) { s.textContent = o.dataset.price; });
        var url = new URL(window.location.href); url.searchParams.set('variant', sel.value);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  /* ---------- Panier latéral ---------- */
  var drawer = null, drawerOpen = false, lastFocus = null;
  function ensureDrawer() {
    if (drawer) return drawer;
    drawer = document.createElement('div');
    drawer.className = 'gx-drawer';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.innerHTML = '<div class="gx-drawer__overlay" data-gx-drawer-close></div><aside class="gx-drawer__panel" role="dialog" aria-modal="true" aria-label="Ton panier" tabindex="-1"><div class="gx gx-drawer__loading">Chargement du panier…</div></aside>';
    document.body.appendChild(drawer);
    return drawer;
  }
  function loadDrawer() {
    var panel = ensureDrawer().querySelector('.gx-drawer__panel');
    return fetch(root + 'cart?section_id=gx-cart-drawer', { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        panel.innerHTML = html;
        var c = panel.querySelector('[data-gx-drawer-content]');
        if (c) updateProgress(parseInt(c.getAttribute('data-count'), 10) || 0);
      });
  }
  function openDrawer() {
    ensureDrawer();
    var t = document.querySelector('.gx-toast'); if (t) t.classList.remove('is-on');
    if (drawerOpen) return loadDrawer();
    lastFocus = document.activeElement;
    drawerOpen = true;
    document.documentElement.classList.add('gx-lock');
    drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    try { history.pushState({ gxDrawer: 1 }, ''); } catch (e) {}
    return loadDrawer().then(function () {
      drawer.classList.remove('gx-opening'); void drawer.offsetWidth; drawer.classList.add('gx-opening');
      clearTimeout(drawer._gxOpen); drawer._gxOpen = setTimeout(function () { drawer.classList.remove('gx-opening'); }, 1600);
      var p = drawer.querySelector('.gx-drawer__panel');
      try { p.focus({ preventScroll: true }); } catch (e) {}
    });
  }
  function closeDrawer(fromPop) {
    if (!drawerOpen) return;
    drawerOpen = false;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('gx-lock');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    if (!fromPop && history.state && history.state.gxDrawer) { try { history.back(); } catch (e) {} }
  }
  function openDrawerAdded() {
    ensureDrawer();
    drawer.classList.remove('gx-added'); void drawer.offsetWidth; drawer.classList.add('gx-added');
    clearTimeout(drawer._gxAdd); drawer._gxAdd = setTimeout(function () { drawer.classList.remove('gx-added'); }, 2200);
    return Promise.resolve(openDrawer()).then(function () {
      var c = drawer.querySelector('[data-gx-drawer-content]');
      if (c && !c.querySelector('.gx-drawer__added')) {
        var b = document.createElement('div');
        b.className = 'gx-drawer__added'; b.setAttribute('role', 'status');
        b.innerHTML = '<span aria-hidden="true">✓</span>Ajouté au panier !';
        var head = c.querySelector('.gx-drawer__head');
        if (head) head.insertAdjacentElement('afterend', b); else c.insertBefore(b, c.firstChild);
      }
    });
  }
  function changeLine(line, qty) {
    var panel = drawer.querySelector('.gx-drawer__panel');
    panel.classList.add('is-busy');
    fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: parseInt(line, 10), quantity: Math.max(0, parseInt(qty, 10) || 0) }) })
      .then(function (r) { return r.json(); })
      .then(function () { return loadDrawer(); })
      .catch(function () {})
      .then(function () { panel.classList.remove('is-busy'); });
  }
  function isCartLink(a) {
    try {
      var u = new URL(a.getAttribute('href'), window.location.href);
      return u.origin === window.location.origin && /\/cart\/?$/.test(u.pathname) && !/\/cart\/?$/.test(window.location.pathname);
    } catch (e) { return false; }
  }
  window.addEventListener('popstate', function () { if (drawerOpen) closeDrawer(true); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawerOpen) closeDrawer(); });
  document.addEventListener('click', function (e) {
    var cl = e.target.closest('[data-gx-drawer-close]');
    if (cl) { e.preventDefault(); closeDrawer(); return; }
    var ln = e.target.closest('[data-gx-line]');
    if (ln && drawer && drawer.contains(ln)) { e.preventDefault(); changeLine(ln.getAttribute('data-gx-line'), ln.getAttribute('data-gx-qty')); return; }
    var ad = e.target.closest('[data-gx-drawer-add]');
    if (ad) {
      e.preventDefault(); ad.disabled = true;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: parseInt(ad.getAttribute('data-gx-drawer-add'), 10), quantity: 1 }) })
        .then(function () { return loadDrawer(); })
        .catch(function () { ad.disabled = false; });
      return;
    }
    var a = e.target.closest('a[href]');
    if (a && !e.metaKey && !e.ctrlKey && !e.shiftKey && !(drawer && drawer.contains(a)) && isCartLink(a)) { e.preventDefault(); openDrawer(); }
  });
  window.GloupixCart = { open: openDrawer, close: closeDrawer, refresh: loadDrawer };

  function refreshCart() {
    if (!window.fetch || !document.querySelector('[data-gx-progress],[data-gx-count]')) return;
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateProgress(cart.item_count); })
      .catch(function () {});
  }
  document.addEventListener('DOMContentLoaded', refreshCart);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refreshCart(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Gloupix : stock restant réel + date de livraison estimée */
(function () {
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  var FERIES = ['1-1', '5-1', '5-8', '7-14', '8-15', '11-1', '11-11', '12-25'];
  function ouvres(n, cal) {
    var d = new Date(); d.setHours(12, 0, 0, 0);
    var c = 0;
    while (c < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (!cal && (w === 0 || w === 6 || FERIES.indexOf((d.getMonth() + 1) + '-' + d.getDate()) > -1)) continue;
      c++;
    }
    return d;
  }
  function jour(d) { return d.getDate() === 1 ? '1er' : String(d.getDate()); }
  function initEta() {
    document.querySelectorAll('[data-gx-eta]').forEach(function (el) {
      var out = el.querySelector('[data-gx-eta-date]');
      if (!out) return;
      var cal = el.getAttribute('data-days') === 'calendar';
      var a = ouvres(parseInt(el.getAttribute('data-min'), 10) || 3, cal);
      var b = ouvres(parseInt(el.getAttribute('data-max'), 10) || 6, cal);
      if (el.getAttribute('data-mode') === 'range' && a.getTime() !== b.getTime()) {
        var debut = a.getMonth() === b.getMonth() ? jour(a) : jour(a) + ' ' + MOIS[a.getMonth()];
        out.innerHTML = 'entre le <strong>' + debut + '</strong> et le <strong>' + jour(b) + ' ' + MOIS[b.getMonth()] + '</strong>';
      } else {
        out.innerHTML = 'd\'ici le <strong>' + jour(b) + ' ' + MOIS[b.getMonth()] + '</strong>';
      }
    });
  }
  function setStock(el, variantId) {
    var map = {};
    (el.getAttribute('data-gx-stock') || '').split(',').forEach(function (p) {
      var kv = p.split(':'); if (kv.length === 2) map[kv[0]] = parseInt(kv[1], 10);
    });
    var thr = parseInt(el.getAttribute('data-gx-thr'), 10) || 10;
    var q = map[String(variantId)] || 0;
    if (!(q > 0 && q <= thr)) { el.hidden = true; return; }
    el.hidden = false;
    var n = el.querySelector('[data-gx-stock-n]'); if (n) n.textContent = q;
    var u = el.querySelector('[data-gx-stock-unit]'); if (u) u.textContent = q > 1 ? 'exemplaires' : 'exemplaire';
    var fl = el.querySelector('.gx-stock__fill'); if (fl) fl.style.width = Math.round(q * 100 / thr) + '%';
  }
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || sel.name !== 'id' || !sel.closest('.gx-pdp')) return;
    var pdp = sel.closest('.gx-pdp');
    pdp.querySelectorAll('[data-gx-stock]').forEach(function (el) { if (!el.hasAttribute('data-gx-demo')) setStock(el, sel.value); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initEta); else initEta();
  document.addEventListener('shopify:section:load', initEta);
  document.addEventListener('shopify:block:select', initEta);
})();

/* Gloupix : animations légères (apparition au scroll, panier qui saute) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function bumpCart() {
    document.querySelectorAll('.gx-iconbtn--cart').forEach(function (b) {
      b.classList.remove('gx-bump'); void b.offsetWidth; b.classList.add('gx-bump');
    });
  }
  function watchCount() {
    if (!window.MutationObserver) return;
    document.querySelectorAll('[data-gx-count]').forEach(function (el) {
      if (el._gxObs) return; el._gxObs = true;
      var last = el.textContent;
      new MutationObserver(function () {
        if (el.textContent !== last) { if (parseInt(el.textContent, 10) > parseInt(last, 10) || isNaN(parseInt(last, 10))) bumpCart(); last = el.textContent; }
      }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }
  document.addEventListener('animationend', function (e) {
    if (e.animationName === 'gx-cart-bump' && e.target.classList) e.target.classList.remove('gx-bump');
  });
  var SEL = '.gx-sec .gx-sec__head, .gx-sec .gx-rail, .gx-sec .gx-grid > *, .gx-parents__text, .gx-parents__media, .gx-sec .gx-faq, .gx-footer__inner > *, .gx-xsell';
  function initReveal() {
    if (reduce || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target; io.unobserve(el);
        el.classList.add('is-in');
        setTimeout(function () { el.classList.remove('gx-reveal', 'is-in'); el.style.removeProperty('--gx-d'); }, 1100);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el._gxRev) return; el._gxRev = true;
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9 && r.bottom > 0) return;
      var sib = el.parentNode ? Array.prototype.indexOf.call(el.parentNode.children, el) : 0;
      el.style.setProperty('--gx-d', ((sib % 4) * 80) + 'ms');
      el.classList.add('gx-reveal');
      io.observe(el);
    });
  }
  function init() { watchCount(); initReveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Gloupix : flèches précédent / suivant des carrousels */
document.addEventListener('click', function (e) {
  var btn = e.target.closest && e.target.closest('[data-gx-rail-prev],[data-gx-rail-next]');
  if (!btn) return;
  var sec = btn.closest('section') || document;
  var rail = sec.querySelector('[data-gx-rail]');
  if (!rail || !rail.children.length) return;
  var step = rail.children[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 16);
  rail.scrollBy({ left: btn.hasAttribute('data-gx-rail-prev') ? -step : step, behavior: 'smooth' });
});

/* Gloupix : ombre de l'en-tête quand il suit le scroll */
(function () {
  var wrap = null, ticking = false;
  function find() { var h = document.querySelector('.gx-header'); wrap = h ? h.parentElement : null; }
  function upd() { ticking = false; if (!wrap) find(); if (wrap) wrap.classList.toggle('gx-stuck', window.scrollY > 8); }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(upd); } }, { passive: true });
  document.addEventListener('DOMContentLoaded', upd);
  document.addEventListener('shopify:section:load', function () { wrap = null; upd(); });
})();

/* Gloupix : défilement automatique des carrousels [data-gx-autoplay] */
(function () {
  function start(rail) {
    if (rail._gxAuto) return; rail._gxAuto = true;
    var paused = false, resume = null;
    function hold() { paused = true; clearTimeout(resume); resume = setTimeout(function () { paused = false; }, 6000); }
    ['touchstart', 'pointerdown', 'wheel', 'mouseenter', 'focusin'].forEach(function (ev) { rail.addEventListener(ev, hold, { passive: true }); });
    setInterval(function () {
      if (paused || document.hidden || !rail.isConnected) return;
      var r = rail.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight || rail.scrollWidth <= rail.clientWidth + 4) return;
      var it = rail.children[0]; if (!it) return;
      var step = it.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 10);
      if (rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 4) rail.scrollTo({ left: 0, behavior: 'smooth' });
      else rail.scrollBy({ left: step, behavior: 'smooth' });
    }, parseInt(rail.getAttribute('data-gx-autoplay'), 10) || 3000);
  }
  function init() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-gx-autoplay]').forEach(start);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Gloupix : recherche instantanée (barre de recherche du header) */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function money(v) { var n = parseFloat(v); if (isNaN(n)) return ''; return n.toFixed(2).replace('.', ',') + ' €'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function bind(wrap) {
    if (wrap._gxP) return; wrap._gxP = true;
    var input = wrap.querySelector('input[name="q"]'), out = wrap.querySelector('[data-gx-predict-out]');
    if (!input || !out) return;
    var timer = null, ctrl = null, last = '';
    function close() { out.hidden = true; out.innerHTML = ''; wrap.classList.remove('is-open'); }
    function run() {
      var q = input.value.trim();
      if (q === last) return; last = q;
      if (q.length < 2) { close(); return; }
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      wrap.classList.add('is-loading');
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag';
      fetch(url, { headers: { 'Accept': 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          wrap.classList.remove('is-loading');
          if (input.value.trim() !== q) return;
          var ps = (j && j.resources && j.resources.results && j.resources.results.products) || [];
          var all = root + 'search?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last';
          var html = '';
          if (!ps.length) {
            html = '<div class="gx-predict__empty">Aucun slime trouvé pour « ' + esc(q) + ' ».<a href="' + root + 'collections/all">Voir tous les slimes</a></div>';
          } else {
            html = '<ul class="gx-predict__list" role="listbox">' + ps.map(function (p) {
              var img = p.image || (p.featured_image && p.featured_image.url) || '';
              if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
              var cmp = parseFloat(p.compare_at_price_max || 0), pr = parseFloat(p.price || 0);
              return '<li role="option"><a href="' + esc(p.url) + '" class="gx-predict__item">' +
                '<span class="gx-predict__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="48" height="48">' : '') + '</span>' +
                '<span class="gx-predict__txt"><span class="gx-predict__name">' + esc(p.title) + '</span>' +
                '<span class="gx-predict__price"><strong>' + money(p.price) + '</strong>' + (cmp > pr ? ' <s>' + money(cmp) + '</s>' : '') + '</span></span>' +
                '<span class="gx-predict__arrow" aria-hidden="true">→</span></a></li>';
            }).join('') + '</ul><a class="gx-predict__all" href="' + all + '">Voir tous les résultats</a>';
          }
          out.innerHTML = html; out.hidden = false; wrap.classList.add('is-open');
        })
        .catch(function () { wrap.classList.remove('is-loading'); });
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 220); });
    input.addEventListener('focus', function () { if (out.innerHTML && input.value.trim().length > 1) { out.hidden = false; wrap.classList.add('is-open'); } });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); input.blur(); } });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) { out.hidden = true; wrap.classList.remove('is-open'); } });
    var form = wrap.querySelector('form');
    if (form) form.addEventListener('submit', function (e) { if (!input.value.trim()) { e.preventDefault(); input.focus(); } });
  }
  function init() { document.querySelectorAll('[data-gx-predict]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Gloupix : compte à rebours [data-gx-countdown] */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function bind(el) {
    if (el._gxCd) return; el._gxCd = true;
    var end = Date.parse(el.getAttribute('data-gx-countdown'));
    if (isNaN(end)) return;
    var q = function (k) { return el.querySelector('[data-gx-cd="' + k + '"]'); };
    var D = q('d'), H = q('h'), M = q('m'), S = q('s');
    var timer;
    function done() {
      clearInterval(timer);
      var design = window.Shopify && Shopify.designMode;
      if (el.getAttribute('data-gx-cd-hide') === 'true' && !design) {
        var sec = el.closest('.shopify-section'); (sec || el).style.display = 'none'; return;
      }
      el.querySelectorAll('[data-gx-cd-live]').forEach(function (n) { n.hidden = true; });
      el.querySelectorAll('[data-gx-cd-done]').forEach(function (n) { n.hidden = false; });
    }
    function set(node, v) { if (node && node.textContent !== v) { node.textContent = v; node.classList.remove('is-tick'); void node.offsetWidth; node.classList.add('is-tick'); } }
    function tick() {
      var diff = Math.floor((end - Date.now()) / 1000);
      if (diff <= 0) { set(D, '00'); set(H, '00'); set(M, '00'); set(S, '00'); done(); return; }
      set(D, pad(Math.floor(diff / 86400))); set(H, pad(Math.floor(diff % 86400 / 3600)));
      set(M, pad(Math.floor(diff % 3600 / 60))); set(S, pad(diff % 60));
    }
    tick(); timer = setInterval(tick, 1000);
  }
  function init() { document.querySelectorAll('[data-gx-countdown]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Gloupix : page Les Duos (filtres, tri, état « Ajouté ») */
(function () {
  function init() {
    document.querySelectorAll('[data-gx-duos-page]').forEach(function (root) {
      if (root._gxDp) return; root._gxDp = true;
      var grid = root.querySelector('[data-gx-dp-grid]');
      if (!grid) return;
      var items = Array.prototype.slice.call(grid.querySelectorAll('[data-gx-dp-item]'));
      var soon = grid.querySelector('[data-gx-dp-soon]');
      var count = root.querySelector('[data-gx-dp-count]');
      var empty = root.querySelector('[data-gx-dp-empty]');
      var sort = root.querySelector('[data-gx-dp-sort]');
      var current = 'all';
      function apply() {
        var mode = sort ? sort.value : 'pop';
        var sorted = items.slice().sort(function (a, b) {
          if (mode === 'asc') return a.dataset.price - b.dataset.price;
          if (mode === 'desc') return b.dataset.price - a.dataset.price;
          return a.dataset.order - b.dataset.order;
        });
        var n = 0;
        sorted.forEach(function (el) {
          var show = (' ' + el.dataset.f + ' ').indexOf(' ' + current + ' ') > -1;
          el.hidden = !show; if (show) n++;
          grid.appendChild(el);
        });
        if (soon) { grid.appendChild(soon); soon.hidden = (n % 2 === 0); }
        if (count) count.textContent = n + ' duo' + (n > 1 ? 's' : '');
        if (empty) empty.hidden = n > 0;
      }
      root.querySelectorAll('[data-gx-dp-f]').forEach(function (b) {
        b.addEventListener('click', function () {
          current = b.getAttribute('data-gx-dp-f');
          root.querySelectorAll('[data-gx-dp-f]').forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on); });
          apply();
        });
      });
      if (sort) sort.addEventListener('change', apply);
      root.addEventListener('gx:added', function (e) {
        var btn = e.target.querySelector && e.target.querySelector('[data-gx-dp-btn]');
        if (!btn) return;
        var label = btn.querySelector('span'); if (!label) return;
        if (!btn._gxLbl) btn._gxLbl = label.textContent;
        label.textContent = 'Ajouté ✓'; btn.classList.add('is-added');
        clearTimeout(btn._gxT); btn._gxT = setTimeout(function () { label.textContent = btn._gxLbl; btn.classList.remove('is-added'); }, 3000);
      });
      apply();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Gloupix : sommaire automatique des articles du Mag */
(function () {
  function slug(t) { return t.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60); }
  function init() {
    document.querySelectorAll('[data-gx-art-body]').forEach(function (body) {
      if (body._gxToc) return; body._gxToc = true;
      var art = body.closest('.gx-art'); if (!art) return;
      var toc = art.querySelector('[data-gx-toc]'), list = art.querySelector('[data-gx-toc-list]');
      var hs = body.querySelectorAll('h2');
      if (!toc || !list || hs.length < 2) return;
      hs.forEach(function (h, i) {
        if (!h.id) h.id = slug(h.textContent) || ('partie-' + (i + 1));
        var li = document.createElement('li'), a = document.createElement('a');
        a.href = '#' + h.id; a.textContent = h.textContent; li.appendChild(a); list.appendChild(li);
      });
      toc.hidden = false;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
